export default __webpack_public_path__ + "static/media/ps_large_hollow_5_grey.53d25914.png";